<div
  class="quota-item"
  [class.expanded]="isExpanded(connectionQuota.connection_name)"
>
  <a
    class="item-header"
    (click)="toggleCard(connectionQuota.connection_name)"
    href="javascript:void(0)"
  >
    <div class="connection-info">
      <h3>{{ connectionQuota.connection_name }}</h3>
    </div>
    <div class="header-stats">
      <div class="stat-card">
        <div class="stat-icon sources">
          <svg viewBox="0 0 24 24">
            <path
              d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"
            />
          </svg>
        </div>
        <div class="stat-info">
          <span class="stat-value">{{ connectionQuota.details.length }}</span>
          <span class="stat-label">Total Sources</span>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon quota">
          <svg viewBox="0 0 24 24">
            <path
              d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
            />
            <path d="M7 12h2v5H7zm4-3h2v8h-2zm4-3h2v11h-2z" />
          </svg>
        </div>
        <div class="stat-info">
          <span class="stat-value">{{
            connectionQuota.details | sum: "max_quota"
          }}</span>
          <span class="stat-label">Total Quota</span>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon available">
          <svg viewBox="0 0 24 24">
            <path
              d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
            />
          </svg>
        </div>
        <div class="stat-info">
          <span class="stat-value">{{
            connectionQuota.details | sum: "available_quota"
          }}</span>
          <span class="stat-label">Available</span>
        </div>
      </div>
    </div>
    <div class="header-actions">
      <button
        class="delete-connection-btn"
        title="Delete all quotas for this connection"
        (click)="$event.stopPropagation(); this.showDeleteConfirmPopup = true"
      >
        <app-svg-icon
          [iconName]="'delete.svg'"
          [height]="'16px'"
          [width]="'16px'"
          [style.fill]="'#64748b'"
        ></app-svg-icon>
      </button>
      <div class="expand-arrow">
        <svg
          viewBox="0 0 24 24"
          [class.expanded]="isExpanded(connectionQuota.connection_name)"
        >
          <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
        </svg>
      </div>
    </div>
  </a>

  @if (isExpanded(connectionQuota.connection_name)) {
    <app-source-quota
      [cdfiLeadsQuota]="connectionQuota"
      [sourceTypes]="sourceTypes"
      (removedAllSourceQuota)="removedAllSourceQuota()"
      (quotaDetailsUpdated)="UpdateInSourceQuotaDetails()"
    ></app-source-quota>
  }
</div>

@if (showDeleteConfirmPopup) {
  <app-popup
    [heading]="'Confirm Delete'"
    [confirmText]="'Delete'"
    [cancelText]="'Cancel'"
    (confirmClicked)="deleteConnectionQuota()"
    (cancelClicked)="showDeleteConfirmPopup = false"
  >
    Are you sure you want to delete all source type quotas for
    {{ connectionQuota.connection_name }}?
  </app-popup>
}
